"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { commonApiFetch } from "@/services/api/common-api";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { ExploreWaveCard } from "./ExploreWaveCard";
import { ExploreWaveCardSkeleton } from "./ExploreWaveCardSkeleton";
const WAVES_LIMIT = 6;
export function ExploreWavesSection() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      queryKey: ["explore-waves-homepage", WAVES_LIMIT],
      queryFn: _temp,
      staleTime: 300000
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: waves,
    isLoading,
    isError
  } = useQuery(t0);
  if (isError) {
    return null;
  }
  if (!isLoading && (!waves || waves.length === 0)) {
    return null;
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="tw-mb-8 tw-flex tw-flex-col tw-items-start tw-gap-4 md:tw-items-end"><div className="md:tw-text-center tw-max-w-sm md:tw-max-w-xl md:tw-mx-auto lg:tw-max-w-full"><span className="tw-m-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-white md:tw-text-2xl">Tired of bot replies? Join the most interesting chats in crypto</span><p className="tw-mb-0 tw-mt-2 tw-text-base tw-text-iron-500">Most active waves</p></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoading || $[3] !== waves) {
    t2 = isLoading ? Array.from({
      length: WAVES_LIMIT
    }).map(_temp2) : waves?.map(_temp3);
    $[2] = isLoading;
    $[3] = waves;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-x-3 tw-gap-y-4 sm:tw-gap-5 lg:tw-grid-cols-3">{t2}</div>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-mt-8 md:tw-mt-10 tw-flex tw-justify-center"><Link href="/waves" className="tw-inline-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-medium tw-text-iron-400 tw-no-underline tw-transition-colors hover:tw-text-white"><span>View all</span><ArrowRightIcon className="tw-size-4 tw-flex-shrink-0" aria-hidden={true} /></Link></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <section className="tw-px-4 tw-py-10 md:tw-px-6 md:tw-py-16 lg:tw-px-8"><div>{t1}{t3}{t4}</div></section>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp3(wave) {
  return <div key={wave.id} className="tw-w-full"><ExploreWaveCard wave={wave} /></div>;
}
function _temp2(_, index) {
  return <div key={`skeleton-${index}`} className="tw-w-full"><ExploreWaveCardSkeleton /></div>;
}
async function _temp() {
  const data = await commonApiFetch({
    endpoint: "waves-overview/hot"
  });
  return data.slice(0, WAVES_LIMIT);
}